import { Text, VStack } from "@gluestack-ui/themed";
import { SelectServicePointsListProps } from "./types";
import { LocationListTile } from "@repo/core/screens/Proposals/components/LocationListTile";
import { MustShow } from "@repo/core/components/core/MustShow";
import { ServicePointsListLoader } from "@repo/core/components/layout/SelectServicePointsList/loading";

export const SelectServicePointsList = ({
  servicePoints,
  selectedServicePoint,
  onSelectServicePoint,
  isLoading
}: SelectServicePointsListProps) => {
  return (
    <VStack gap="$6">
      <Text fontSize="$md" fontWeight={400} color="$textLight800">
        Selecione o ponto de atendimento
      </Text>
      <MustShow isVisible={!isLoading} fallback={<ServicePointsListLoader />}>
        <VStack gap="$4">
          {servicePoints?.map((item) => (
            <LocationListTile
              key={item.ponto}
              id={item.ponto}
              name={item.descricao}
              isActive={item.ponto === selectedServicePoint}
              onPress={onSelectServicePoint}
            />
          ))}
        </VStack>
      </MustShow>
    </VStack>
  );
};
